import React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './UserPassItem.module.scss';
import clsx from 'clsx';
import { imageUrl } from '../../utils/imageUrl';
import Input from '../Input/Input';
import { useForm } from 'react-hook-form';
import Link from '../Link/Link';
import { gameUserAdd } from '../../redux/actions/game/gameUserAdd';
import Swal from 'sweetalert2';
import { gameUserList } from '../../redux/actions/game/gameUserList';
import { gameUserSwitchActive } from '../../redux/actions/game/gameUserSwitchActive';
const UserPassItem = ({ id, index, logo, name, serviceGames, userGames }) => {
  const {
    gameUserAdd: { data: gameUserAddData, loading: gameUserAddLoading, error: gameUserAddError },
  } = useSelector((state) => state.game);

  const {
    gameUserSwitchActive: { data: gameUserSwitchActiveData, loading: gameUserSwitchActiveLoading, error: gameUserSwitchActiveError },
  } = useSelector((state) => state.game);

  const playerId = userGames?.[0]?.playerId;
  const active = userGames?.[0]?.active;
  const userGameId = userGames?.[0]?.id;
  useEffect(() => {
    if (gameUserAddData) {
      dispatch(gameUserList());
    }
  }, [gameUserAddData]);

  useEffect(() => {
    if (gameUserSwitchActiveData) {
      dispatch(gameUserList());
    }
  }, [gameUserSwitchActiveData]);

  useEffect(() => {
    if (userGames?.length) {
      form.setValue('playerId', userGames[0]?.playerId);
    }
  }, [userGames]);

  const onSave = (data) => {
    Swal.fire({
      icon: 'warning',
      title: `Сохранить игровой ID для этой игры ?`,
      text: 'Внимательно проверьте заполненный игровой ID. После сохранения, игровой ID можно будет изменить только через тех.поддержку',
      showCancelButton: true,
      showConfirmButton: true,
      background: '#fff',
      cancelButtonColor: '#fc564a',
      cancelButtonText: 'Отмена',
      confirmButtonColor: '#65c15c',
      confirmButtonText: 'Сохранить',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(gameUserAdd({ playerId: data.playerId, gameId: id }));
      }
    });
  };

  const onSwitchActive = (data) => {
    Swal.fire({
      icon: 'info',
      title: `Вы уверены что хотите ${active ? 'отключить' : 'включить'} игру`,
      showCancelButton: true,
      showConfirmButton: true,
      background: '#fff',
      cancelButtonColor: '#fc564a',
      cancelButtonText: 'Отмена',
      confirmButtonColor: '#65c15c',
      confirmButtonText: active ? 'Отключить' : 'Включить',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(gameUserSwitchActive({ userGameId }));
      }
    });
  };
  const getStatus = () => {
    if (!serviceGames?.length) {
      return 'UNAVAILABLE';
    } else if (!playerId) {
      return '';
    } else if (active) {
      return 'ACTIVE';
    } else if (!active) {
      return 'DISABLED';
    }
  };
  const form = useForm();
  // const isDisabled = !serviceGames?.length;
  // const isActive = !isDisabled;
  const dispatch = useDispatch();
  const status = getStatus();

  return (
    <>
      <div className={clsx(styles.wrap, status == 'UNAVAILABLE' && styles.wrapDisable)}>
        <div className={clsx(styles.number)}>{index}</div>
        <div className={clsx(styles.content)}>
          <div className={clsx(styles.top)}>
            <img src={imageUrl(logo)} alt="" className={clsx(styles.logo)} />
            <div className={clsx(styles.name)}>{name}</div>

            <Input className={clsx(styles.inputPlayerId)} name="playerId" form={form} label="Ваш игровой ID" disabled={playerId || status == 'UNAVAILABLE'} />
            {status == 'UNAVAILABLE' ? (
              <>
                <div></div>
                <div></div>
              </>
            ) : (
              <>
                {playerId ? (
                  <div className={clsx(styles.icon, styles.edit)} onClick={form.handleSubmit(onSave)} data-tooltip-id="tooltip" data-tooltip-content="Написать в тех.поддержку для смены">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-message-square">
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                    </svg>
                  </div>
                ) : (
                  <div className={clsx(styles.icon, styles.edit)} onClick={form.handleSubmit(onSave)} data-tooltip-id="tooltip" data-tooltip-content="Cохранить">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-save">
                      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
                      <polyline points="17 21 17 13 7 13 7 21"></polyline>
                      <polyline points="7 3 7 8 15 8"></polyline>
                    </svg>
                  </div>
                )}
                {(status == 'ACTIVE' || status == 'DISABLED') && (
                  <div data-tooltip-id="tooltip" data-tooltip-content="Выключить" className={clsx(styles.icon, status == 'ACTIVE' ? styles.active : styles.disable)} onClick={onSwitchActive}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-power">
                      <path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path>
                      <line x1="12" y1="2" x2="12" y2="12"></line>
                    </svg>
                  </div>
                )}
              </>
            )}
          </div>
          <div className={clsx(styles.bottom)}>
            <div className={clsx(styles.serviceList)}>
              {serviceGames?.map((item) => (
                <div className={clsx(styles.serviceItem)}>
                  <Link
                    className={clsx(styles.serviceLink)}
                    onClick={() => {
                      let fullUrl = item?.service?.site;

                      if (!fullUrl.startsWith('http://') && !fullUrl.startsWith('https://')) {
                        fullUrl = 'https://' + fullUrl; // По умолчанию https
                      }

                      window.open(fullUrl, '_blank', 'noopener,noreferrer');
                    }}>
                    {item?.service?.name}
                  </Link>

                  <div className={clsx(styles.servicePercent)}>{item?.percent}%</div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className={clsx(styles.status, status == 'DISABLED' && styles.statusDisable, status == 'UNAVAILABLE' && styles.statusUnavailable)}>{status == 'ACTIVE' ? 'Активно' : status == 'DISABLED' ? 'Неактивно' : status == 'UNAVAILABLE' ? 'Недоступно' : ''}</div>
      </div>
    </>
  );
};

export default UserPassItem;
